// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\n/* Importing Bootstrap SCSS file. */", "",{"version":3,"sources":["styles.scss"],"names":[],"mappings":"AAAA,8EAAA;AAEA,mCAAA","file":"styles.scss","sourcesContent":["/* You can add global styles to this file, and also import other style files */\r\n\r\n/* Importing Bootstrap SCSS file. */\r\n// @import '~bootstrap/scss/bootstrap';\r\n"]}]);
// Exports
module.exports = exports;
